<section class="cta-sect" id="contacto" appViewportEnterDirective (viewPortEntered)="activeRoute.setActiveRoute('home-contact')">
    <img src="./assets/AdminAI-blanco.png" alt="logo Adminai" class="logo">
    <!-- <img src="./assets/footer-texture1.png" class="texture f" alt="">
    <img src="./assets/footer-texture2.png" class="texture l" alt=""> -->
    <a  routerLink="/auth/register" class="button-primary-3">Suscribite ya</a>
    <div class="social-cont">
        <a href="https://www.instagram.com/adminai.oficial" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-340.000000, -7439.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792" id="instagram-[#167]"> </path> </g> </g> </g> </g>
            </svg>
            
        </a>
        <a href="https://www.linkedin.com/company/adminaioficial" target="_blank" rel="noopener noreferrer">
            <svg fill="#ffffff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>linkedin</title> <path d="M28.778 1.004h-25.56c-0.008-0-0.017-0-0.027-0-1.199 0-2.172 0.964-2.186 2.159v25.672c0.014 1.196 0.987 2.161 2.186 2.161 0.010 0 0.019-0 0.029-0h25.555c0.008 0 0.018 0 0.028 0 1.2 0 2.175-0.963 2.194-2.159l0-0.002v-25.67c-0.019-1.197-0.994-2.161-2.195-2.161-0.010 0-0.019 0-0.029 0h0.001zM9.9 26.562h-4.454v-14.311h4.454zM7.674 10.293c-1.425 0-2.579-1.155-2.579-2.579s1.155-2.579 2.579-2.579c1.424 0 2.579 1.154 2.579 2.578v0c0 0.001 0 0.002 0 0.004 0 1.423-1.154 2.577-2.577 2.577-0.001 0-0.002 0-0.003 0h0zM26.556 26.562h-4.441v-6.959c0-1.66-0.034-3.795-2.314-3.795-2.316 0-2.669 1.806-2.669 3.673v7.082h-4.441v-14.311h4.266v1.951h0.058c0.828-1.395 2.326-2.315 4.039-2.315 0.061 0 0.121 0.001 0.181 0.003l-0.009-0c4.5 0 5.332 2.962 5.332 6.817v7.855z"></path> </g>
            </svg>

        </a>
    </div>
</section>
<footer class="footer">
    <!-- <ul class="links-list">
        <li>
            <ul class="sublist">
                <li>Producto</li>
                <li> 
                    <a routerLink="/" fragment="caracteristicas">Características</a>
                </li>
                <li>
                    <a routerLink="/" fragment="como">
                        Cómo Funciona
                    </a>
                    </li>
                <li>
                    <a routerLink="/" fragment="planes">
                        Planes
                    </a>
                </li>
                <li>
                    <a routerLink="/">
                        Demo
                    </a>
                </li>
            </ul>
        </li>
        <li>
            <ul class="sublist">
                <li>
                        Soporte
                </li>
                <li>
                    <a href="">
                        Capacitaciones gratuitas
                    </a>
                </li>
                <li>
                    <a href="">
                        Guía del usuario
                    </a>
                </li>
                <li>
                    <a href="">
                        Contactar con soporte
                    </a>
                </li>
            </ul>
        </li>
        <li>
            <ul class="sublist">
                <li>Empresa</li>
                <li>
                    <a href="">
                        Sobre nosotros
                    </a>
                </li>
            </ul>
        </li>
        <li>
            <ul class="sublist">
                <li>Legal</li>
                <li>
                    <a href="">
                        Política de Privacidad
                    </a>
                </li>
                <li>
                    <a href="">

                        Términos y Condiciones
                    </a>
                </li>
            </ul>
        </li>
    </ul> -->
        <div class="legal-links">
            <a routerLink="/privacy-policy" class="link">Política de privacidad</a>
            <a routerLink="/terms-and-conditions" class="link">Términos y condiciones</a>
            <a routerLink="/data-deletion" class="link">Eliminación de datos</a>
        </div>

    <p class="subfooter">
        © 2026 AdminAI S.A. Todos los derechos reservados.
    </p>
</footer>